import { render, staticRenderFns } from "./PartnerManager.vue?vue&type=template&id=81c32c9c&"
import script from "./PartnerManager.vue?vue&type=script&lang=js&"
export * from "./PartnerManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports